import * as path from 'node:path';

export interface SnapshotRepoState {
  path: string;
  stashSha: string;
  untrackedPaths?: string[];
}

export interface PreTurnSnapshotFile {
  runId: string;
  createdAt: string;
  repos: SnapshotRepoState[];
}

export function snapshotsDirForCwd(agentCwd: string): string {
  return path.join(agentCwd, '.buildautomaton', 'snapshots');
}

export function snapshotFilePath(agentCwd: string, runId: string): string {
  return path.join(snapshotsDirForCwd(agentCwd), `${runId}.json`);
}
